import {useTaggingClick} from "@/hooks/common/useTagging";
import publicRuntimeConfig from "@FRAMEWORK/config/public";
import * as style from "@FRAMEWORK/ui/desktop/header/NewHeader";
import useGlobalBannerText, {GlobarBannerText} from "@QUERIES/bff/global/useGlobalBannerText";
import {useEffect, useMemo, useState} from "react";

/**
 * 헤더 검색 영역
 */
const SearchArea = () => {
	const globalBannerTextFetch = useGlobalBannerText();
	const globalBannerText = globalBannerTextFetch.data?.body || [];

	const filteredBannerText = useMemo(() => globalBannerText.filter(o => o.pcYn === "Y"), [globalBannerText]);

	const [bannerText, setBannerText] = useState<GlobarBannerText>(null);
	useEffect(() => {
		if (filteredBannerText.length > 0) {
			setBannerText(filteredBannerText[Math.floor(Math.random() * filteredBannerText.length)]);
		}
	}, [filteredBannerText]);

	const {taggingClick} = useTaggingClick("pkg_search_keyword", bannerText);

	return (
		<style.SearchWrap>
			<a href={`${publicRuntimeConfig.ENV_PACKAGE_URL}/common/searchGoods.yb`}>{bannerText?.keyword || ""}</a>
			<style.BtnSearch
				type="button"
				onClick={() => {
					taggingClick();
					const url = bannerText?.pcUrl || `${publicRuntimeConfig.ENV_PACKAGE_URL}/common/searchGoods.yb`;
					location.href = url;
				}}
			>
				<span>검색</span>
			</style.BtnSearch>
		</style.SearchWrap>
	);
};

export default SearchArea;
